import React from "react";
// import Chart from "./Components/Chart.js";
import { Route, Routes } from "react-router-dom";
import Dashboard from "./Components/Dashboard.js";
import ForgotPass from "./Components/ForgotPass.js";
import Login from "./Components/Login.js";
import NewPassword from "./Components/NewPassword.js";
import SignUp from "./Components/SignUp.js";
import SignUpPhase2 from "./Components/SignUpPhase2.js";
import SignupPhase3 from "./Components/SignupPhase3.js";
import SignUp_Varification from "./Components/SignUp_Varification.js";





function App() {
  return (
   <Routes>
     <Route path="/" element={<Login />}/>
     <Route path="/SignUp" element={<SignUp />}/>
     <Route path="/SignUpPhase2" element={<SignUpPhase2/>} />
     <Route path="/SignUpPhase3"  element={<SignupPhase3/>}/>
     <Route path="/SignUp_Varification"  element={<SignUp_Varification/>}/>
     <Route path="/ForgotPass" element={<ForgotPass/>}/>
     <Route path="/NewPassword" element={<NewPassword/>} />
     <Route path="/Dashboard" element={<Dashboard/>}    />
   </Routes>
  // <>
  // <Chart/>
  // </>
  );
}

export default App;
